import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
Vue.use(Router)
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/error',
    component: Layout,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    meta: {
      title: 'errorPages',
      icon: '404'
    },
    children: [
      {
        path: '404',
        component: () => import('@/views/error-page/404'),
        name: 'Page404',
        meta: { title: 'page404', noCache: true }
      },
      {
        path: '401',
        component: () => import('@/views/error-page/401'),
        name: 'Page401',
        meta: { title: 'page401', noCache: true }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/transfer/index',
    component: () => import('@/views/transfer/index'),
    hidden: true,
    name: '中转页面'
  },
  {
    path: '/store-home-page/index',
    component: () => import('@/views/store-home-page/index'),
    hidden: false,
    name: '商店首页',
    meta: { title: '商店首页', icon: 'user', noCache: true }
  },
  {
    path: '/upgrade-management/queue',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/upgrade-management/queue'),
        name: 'UpgradeQueue',
        meta: { title: '升级队列', noCache: true }
      }
    ]
  },
  {
    path: '/upgrade-management/bulk-package-diff',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/upgrade-management/bulk-package-diff'),
        name: 'UpgradeBulkPackageDiff',
        meta: { title: '升级小程序', noCache: true }
      }
    ]
  },
  {
    path: '/deploy-manage/deploy-app/mini-app-binding',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/deploy-manage/deploy-app/mini-app-binding'),
        name: 'DeployMiniAppBinding',
        meta: { title: '绑定小程序', noCache: true }
      }
    ]
  }
]

export const asyncRouter = []

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode: 'history',
  routes: constantRoutes
})

// let asyncRouter
const router = createRouter()

// 重置路由
export function resetRouter(asyncRouter) {
  let userRoutes = asyncRouter
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
  router.options.routes = []
  userRoutes = filterAsyncRouter(userRoutes)
  router.addRoutes(userRoutes)
}

function filterAsyncRouter(routes) {
  return routes.filter((route) => {
    const component = route.component
    if (component) {
      if (route.component === 'Layout') {
        route.component = Layout
      } else {
        route.component = view(component)
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      return true
    }
  })
}
function view(path) {
  return (resolve) => require([`@/views/${path}.vue`], resolve)
}
export default router
